var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<span>00:00</span>";
ngModule.run(["$templateCache",function(c){c.put("timer/templates/timer.html",v1)}]);
module.exports=v1;


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/timer/templates/timer.html
 ** module id = 65
 ** module chunks = 1
 **/